function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Vector2d } from "@stage/math";
import { ArcCurve, CubicBezierCurve, LineCurve, QuadraticBezierCurve } from "./curve";
export var PathCurve = /*#__PURE__*/function () {
  function PathCurve() {
    var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2d();
    var curves = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, PathCurve);
    _defineProperty(this, "begin", void 0);
    _defineProperty(this, "curves", void 0);
    _defineProperty(this, "close", false);
    this.begin = begin;
    this.curves = curves;
  }
  _createClass(PathCurve, [{
    key: "_push",
    value: function _push(curve) {
      this.curves.push(curve);
      return this;
    }
  }, {
    key: "lineTo",
    value: function lineTo(end) {
      return this._push(new LineCurve(end));
    }
  }, {
    key: "quadraticBezierTo",
    value: function quadraticBezierTo(c, end) {
      return this._push(new QuadraticBezierCurve(c, end));
    }
  }, {
    key: "cubicBezierTo",
    value: function cubicBezierTo(cs, ce, end) {
      return this._push(new CubicBezierCurve(cs, ce, end));
    }

    /**
     *
     * @param rx 椭圆x半轴
     * @param ry 椭圆y半轴
     * @param axisRotation 椭圆相对于坐标系的旋转角度
     * @param lrc 大弧，小弧
     * @param sweep 是否顺时针
     * @param end 圆弧终点
     */
  }, {
    key: "arcTo",
    value: function arcTo(rx, ry, axisRotation, lrc, sweep, end) {
      return this._push(new ArcCurve(rx, ry, axisRotation, lrc, sweep, end));
    }
  }, {
    key: "closepath",
    value: function closepath() {
      this.close = true;
    }
  }]);
  return PathCurve;
}();